import React from 'react';
import './FooterOverlay.css';
const FooterOverlay = () => (
  <div className="footerOverlay">
    <div className="footerOverlay-black" />
    <div className="footerOverlay-img app__bg" />
  </div>
);
export default FooterOverlay;
